"use strict";

$(window).scroll(function () {
  $(".header-inner").css("opacity", 1 - $(window).scrollTop() / 400);
});